import { type RefObject } from 'react';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function useScrollReveal(
  ref: RefObject<HTMLElement | null>,
  options?: { stagger?: number; y?: number; children?: boolean }
) {
  useGSAP(() => {
    if (!ref.current) return;
    const target = options?.children !== false ? ref.current.children : [ref.current];
    gsap.from(target, {
      y: options?.y ?? 40,
      opacity: 0,
      duration: 0.8,
      stagger: options?.stagger ?? 0.1,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: ref.current,
        start: 'top 85%',
        once: true,
      },
    });
  }, { scope: ref });
}

export function useScrollRevealSingle(
  ref: RefObject<HTMLElement | null>,
  options?: { y?: number; x?: number; delay?: number; duration?: number }
) {
  useGSAP(() => {
    if (!ref.current) return;
    gsap.from(ref.current, {
      y: options?.y ?? 40,
      x: options?.x ?? 0,
      opacity: 0,
      duration: options?.duration ?? 0.8,
      delay: options?.delay ?? 0,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: ref.current,
        start: 'top 85%',
        once: true,
      },
    });
  }, { scope: ref });
}